enum TokenType {
    NoAuth = 'NoAuth',
    ConnectorsLTI = 'ConnectorsLTI',
    AAD = 'AAD',
}

export default TokenType;
